import React from "react";

export default function Landing({ onEnter }) {
  return (
    <div className="fixed inset-0 z-[70] overflow-hidden bg-[#05060a]">
      {/* flag background */}
      <img
        src="/flag.png"
        alt=""
        aria-hidden
        className="flag-breathe absolute inset-0 h-full w-full object-cover"
        style={{ opacity: 0.6, filter: "blur(3px)" }}
      />
      {/* dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80" />

      {/* ribbon top-right */}
      <div className="absolute top-6 right-6 landing-rise flex flex-col items-center" style={{ animationDelay: "0.3s", opacity: 0 }}>
        <img src="/ribbon_t.png" alt="Remembrance ribbon" className="h-16 sm:h-20 drop-shadow-[0_4px_12px_rgba(0,0,0,0.6)]" />
        <p className="mt-2 font-serif-display text-white text-sm sm:text-lg tracking-wide text-center leading-tight">
          We Will Never<br />Forget
        </p>
      </div>

      {/* content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        <div className="landing-rise" style={{ opacity: 0 }}>
          <div className="h-24 w-24 sm:h-28 sm:w-28 mx-auto rounded-full overflow-hidden border-2 border-[#D4AF37]/80 shadow-[0_8px_30px_rgba(0,0,0,0.6)] ring-2 ring-[#F4E3A1]/20">
            <img src="/tab-seal.png" alt="TAB seal" className="h-full w-full object-cover" />
          </div>
        </div>
        <h1 className="landing-rise font-serif-display text-white text-4xl sm:text-6xl lg:text-7xl font-light tracking-wide mt-8" style={{ animationDelay: "0.15s", opacity: 0 }}>
          World Trade Center
        </h1>
        <div className="landing-rise font-serif-display text-[#F4E3A1] text-3xl sm:text-5xl font-light mt-3" style={{ animationDelay: "0.3s", opacity: 0 }}>
          2001 <span className="text-stone-400 mx-2">—</span> Present
        </div>
        <p className="landing-rise font-mono-tele text-[10px] sm:text-xs tracking-[0.35em] text-stone-300 uppercase mt-4" style={{ animationDelay: "0.45s", opacity: 0 }}>
          A 25th Anniversary Spatial Memorial
        </p>
        <button
          data-testid="landing-enter-btn"
          onClick={onEnter}
          className="landing-rise mt-10 rounded-full bg-[#D4AF37] hover:bg-[#e6c84a] text-[#0b0c10] px-10 py-3.5 text-sm font-semibold tracking-widest uppercase hover:scale-[1.05] transition-[transform,background-color] shadow-[0_8px_30px_rgba(212,175,55,0.4)]"
          style={{ animationDelay: "0.6s", opacity: 0 }}
        >
          Enter Experience
        </button>
      </div>
    </div>
  );
}
